export const toHankakuNumber = (str: string) =>
  str.replace(/[０-９．]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0)).replace(/[－ー−―‐ｰ]/g, "-")

export const removeBrTag = (value: string) => value.replace(/<br\/>/g, "")
export const removeWhiteSpaceCharacter = (value: string) => value.replace(/\s/g, "")

/**
 * 文字列に含まれている全角ひらがなを、全角カタカナに変換します。
 */
export const toKatakana = (str: string) => {
  return str.replace(/[\u3041-\u3096]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0x60))
}

/**
 * 引数の値が null または 空文字の場合に true を返す関数
 * @param {string | null} value - チェックしたい値
 * @returns {boolean} - 値が null または 空文字であれば true、それ以外は false
 */
export const isBlank = (value: string | null): boolean => {
  return value === null || value === ""
}
